import React, {Component, PropTypes} from 'react';
import { connect } from 'react-redux'
import { asyncConnect } from 'redux-async-connect'
import CSSModules from 'react-css-modules'
import Loader from 'react-loader'
import { Row, Col } from 'react-flexbox-grid'
import config from 'config'
import container from '../../helpers/container'
import {
  ContainerDivs,
  Link,
  LinkIcon,
  AutocompleteSearch,
  // AssetManagerLetter,
  IyvScorecard,
} from '../../components'
import Styles from './MutualFundsETFs.css'
import * as searchActions from 'redux/modules/search'

@connect(
  state => ({
    result: state.shareClass.result,
    loading: state.shareClass.loading,
    loaded: state.shareClass.loaded,
    error: state.shareClass.error
  }),
  searchActions)
@asyncConnect([{
  // need otherwise cient navigate is blocked until the page is loaded
  deferred: true,
  promise: ({params, store: {dispatch, getState}}) => {
    return dispatch(
      searchActions.shareClassDetails(
        params.fundId,
        params.investmentVehicleId
      )
    )
  }
}])
@CSSModules(Styles, {allowMultiple:true})
export default class MutualFundsETFs extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    loaded: PropTypes.bool,
    error: PropTypes.object,
    result: PropTypes.object,
  }
  static contextTypes =  {
    router: PropTypes.object.isRequired
  }
  constructor(props) {
    super(props)
    this.state = {
      title: 'Mutual funds and ETFs',
      description: 'See how mutual funds popular in employee retirement plans are rated on environmental and social sustainability issues.',
      url: config.domain + config.routes.mutualFundsETFs
    }
  }

  render() {
    if (!this.props.result) {
      return (
        <div styleName='main'>
          <Loader
            options={{scale: 0.70, top:'2.0rem'}}
            loaded={false}
          />
        </div>
      )
    }
    const { shareClass, fund } = this.props.result

    const fff = require( '../../../static/images/iyv-thumbs/fff-thumbnail.jpg' )
    const dff = require( '../../../static/images/iyv-thumbs/dff-thumbnail.jpg' )
    const gef = require( '../../../static/images/iyv-thumbs/gef-thumbnail.jpg' )
    const gff = require( '../../../static/images/iyv-thumbs/gff-thumbnail.jpg' )
    const pff = require( '../../../static/images/iyv-thumbs/pff-thumbnail.jpg' )
    const wff = require( '../../../static/images/iyv-thumbs/wff-thumbnail.jpg' )
    const tff = require( '../../../static/images/iyv-thumbs/tff-thumbnail.jpg' )
    const goodBadImg = require('../../../static/images/good-and-bad.jpg')

    //
    return (
      <div styleName='page'>
        {
          container.helmet(
            this.state.title,
            this.state.description,
            this.state.url
          )
        }

        <div styleName='search-box'>
          <ContainerDivs>
            <div styleName='search-box-inner'>
              <div styleName='search-box-search'>
                <div styleName='search-box-label'>
                  <h1>
                    Check if your mutual funds and ETFs are climate safe
                  </h1>
                </div>
                <br/>
                <AutocompleteSearch />
                <div styleName='search-box-link'>
                  <Link
                    to={config.routes.clean}
                    title={'Full list'}
                  >
                    Full list<LinkIcon />
                  </Link>
                </div>
              </div>
              <div styleName='search-box-img'>
                <img
                  src={goodBadImg}
                  alt={'Search mutual funds'}
                />
              </div>
            </div>
          </ContainerDivs>
        </div>
        <ContainerDivs>

          {
            shareClass && fund ?
              <div>
                { /* <AssetManagerLetter fundFamilyName={fund.fund_family_name}/> */ }
                <IyvScorecard fund={fund} shareClass={shareClass}/>
              </div> :
              null
          }

          { /* <div styleName='copy'>
            <p>Since 2015, As You Sow’s <Link xstrong to="https://fossilfreefunds.org/">Fossil Free Funds</Link> has been analyzing the holdings of mutual funds and rating them on fossil fuel
            investments and overall carbon footprint. Our fund screeners are 100% free to
            use, and provide transparency to find out if mutual funds are investing in
            oil majors like ExxonMobil and Chevron, coal mining companies
            like BHP, and fossil-fired utilities like Duke Energy.</p>

            <p>Since we released Fossil Free Funds, we’ve expanded our
            sustainability ratings to include <Link xstrong to="https://deforestationfreefunds.org/">deforestation</Link>,
            as well as social issues like <Link xstrong to="https://genderequalityfunds.org/">gender
            equality</Link>, <Link xstrong to="https://gunfreefunds.org/">civilian firearms</Link>, <Link xstrong to="https://prisonfreefunds.org/">the prison industrial complex</Link>, <Link xstrong to="https://weaponfreefunds.org/">arms manufacturers and military contractors</Link>,
            and <Link xstrong to="https://tobaccofreefunds.org/">tobacco</Link>.</p>
          </div>

          <nav>
            <Row>
              <Col xs={12} sm={6} styleName='iyv-thumb-c'>
                <Link
                  to={'https://fossilfreefunds.org/'}
                  title='Fossil Free Funds'
                >
                  <img
                    src={fff}
                    alt='Fossil Free Funds'
                    styleName='iyv-thumb'
                  />
                </Link>
              </Col>
              <Col xs={12} sm={6} styleName='iyv-thumb-c'>
                <Link
                  to={'https://deforestationfreefunds.org/'}
                  title='Deforestation Free Funds'
                >
                  <img
                    src={dff}
                    alt='Deforestation Free Funds'
                    styleName='iyv-thumb'
                  />
                </Link>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={6} styleName='iyv-thumb-c'>
                <Link
                  to={'https://genderequalityfunds.org/'}
                  title='Gender Equality Funds'
                >
                  <img
                    src={gef}
                    alt='Gender Equality Funds'
                    styleName='iyv-thumb'
                  />
                </Link>
              </Col>
              <Col xs={12} sm={6} styleName='iyv-thumb-c'>
                <Link
                  to={'https://gunfreefunds.org/'}
                  title='Gun Free Funds'
                >
                  <img
                    src={gff}
                    alt='Gun Free Funds'
                    styleName='iyv-thumb'
                  />
                </Link>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={6} styleName='iyv-thumb-c'>
                <Link
                  to={'https://prisonfreefunds.org/'}
                  title='Prison Free Funds'
                >
                  <img
                    src={pff}
                    alt='Prison Free Funds'
                    styleName='iyv-thumb'
                  />
                </Link>
              </Col>
              <Col xs={12} sm={6} styleName='iyv-thumb-c'>
                <Link
                  to={'https://weaponfreefunds.org/'}
                  title='Weapon Free Funds'
                >
                  <img
                    src={wff}
                    alt='Weapon Free Funds'
                    styleName='iyv-thumb'
                  />
                </Link>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={3} />
              <Col xs={12} sm={6} styleName='iyv-thumb-c'>
                <Link
                  to={'https://tobaccofreefunds.org/'}
                  title='Tobacco Free Funds'
                >
                  <img
                    src={tff}
                    alt='Tobacco Free Funds'
                    styleName='iyv-thumb'
                  />
                </Link>
              </Col>
              <Col xs={12} sm={3} />
            </Row>
          </nav>  */ }
          
        </ContainerDivs>

        <br/>
        <br/>
        <br/>

      </div>
    )
  }
}